"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.queryIteratorPath = exports.query = void 0;
exports.querySlugFunction = querySlugFunction;
exports.queryTitleFunction = queryTitleFunction;
var query = "\n  query {\n    allFishermanBusinessMenuCategory(sort: { order: ASC, fields: order }) {\n      nodes {\n        _id\n        name\n        order\n        schedule {\n          name\n          order\n        }\n      }\n    }\n  }\n";
exports.query = query;
var queryIteratorPath = ['allFishermanBusinessMenuCategory', 'nodes'];
exports.queryIteratorPath = queryIteratorPath;
function querySlugFunction(queryResult) {
  var queryResults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    slugify = _ref.slugify;
  var name = queryResult.name,
    _id = queryResult._id;
  var slugifyOptions = {
    replaceSlashes: true
  };
  var duplicateCategories = queryResults.filter(function (_ref2) {
    var aName = _ref2.name;
    return aName === name;
  });
  if (duplicateCategories.length <= 1) {
    return slugify(name, slugifyOptions);
  }
  var categoryIndex = duplicateCategories.findIndex(function (_ref3) {
    var aId = _ref3._id;
    return aId === _id;
  });
  return slugify("".concat(name, " ").concat(categoryIndex + 1), slugifyOptions);
}

// eslint-disable-next-line no-unused-vars
function queryTitleFunction(queryResult) {
  var queryResults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var name = queryResult.name;
  return name;
}